<template>
  <el-container class="app-wrapper">
    <!-- 顶部导航 -->
    <el-header height="60px" class="app-header">
      <div class="header-left">
        <div class="logo" @click="_toIndex">{{ systemInfo.systemSimpleTitle }}</div>
        <el-menu mode="horizontal" :default-active="activeMenu" class="header-menu" background-color="#1e2132"
          text-color="#fff" active-text-color="#409EFF">
          <template v-for="(item, index) in catalogs">
            <el-menu-item :index="item.caId" v-if="!item.privId || hasPrivilege(item.privId)" :key="index"
              @click="_changeMenuCatalog(item, true)">{{ item.name }}</el-menu-item>
          </template>
        </el-menu>
      </div>
      <div class="header-right">
        <el-popover v-if="_todoBellEntries().length > 1" ref="todoBellPopover" placement="bottom-end" trigger="click" width="240">
          <div class="todo-panel">
            <div v-for="entry in _todoBellEntries()" :key="entry.item.key" class="todo-panel-row"
              @click="_gotoTodoItemFromPanel(entry)">
              <span class="todo-panel-name">{{ $t(entry.item.todoLabelKey) }}</span>
              <span class="todo-panel-count">{{ entry.count > 99 ? '99+' : entry.count }}</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
          <div slot="reference" class="todo-bell" :title="$t('layout.todoBellTip')">
            <i class="fa fa-bell"></i>
            <span class="todo-badge" v-if="todoTotalCount > 0">{{ todoTotalCount > 99 ? '99+' : todoTotalCount }}</span>
          </div>
        </el-popover>
        <div v-else class="todo-bell"
          :title="_todoBellEntries().length === 1 ? $t(_todoBellEntries()[0].item.todoTipKey, { count: _todoBellEntries()[0].count }) : $t('layout.todoBellTip')"
          @click="_gotoTodoItem(_todoBellEntries().length === 1 ? _todoBellEntries()[0].item : null)">
          <i class="fa fa-bell"></i>
          <span class="todo-badge" v-if="todoTotalCount > 0">{{ todoTotalCount > 99 ? '99+' : todoTotalCount }}</span>
        </div>
        <el-dropdown @command="changeCommunity" v-if="storeInfo.storeTypeCd == '800900000003'" class="margin-right">
          <span class="user-info">
            {{ curCommunityName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="c" v-for="(c, index) in communitys" :key="index">{{ c.name }}</el-dropdown-item>
            <el-dropdown-item command="moreCommunity" class="moreCommunity">{{ $t('layout.moreCommunity')
              }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown @command="handleCommand">
          <span class="user-info">
            {{ username }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">{{ $t('layout.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="margin-left">{{ systemInfo.version }}</span>

      </div>
    </el-header>

    <el-container>
      <!-- 左侧菜单 width="64px"-->
      <el-aside class="app-aside" width="80">
        <div class="vc-menu flex justify-start" id="menu-nav">
          <div class="vc-menu-main">
            <ul>
              <template v-for="(menu, index) in menuTree">
                <li :key="index" v-if="menu.childs && menu.childs.length > 0" :class="{ active: menu.active }"
                  @click="switchMenu(menu)">
                  <span class="menu-name">{{ menu.name }}</span>
                  <span class="menu-red-dot"
                    v-if="_todoMenuGroupCount(menu) > 0">{{ _todoMenuGroupCount(menu) > 99 ? '99+' :
                      _todoMenuGroupCount(menu) }}</span>
                </li>
              </template>
            </ul>
          </div>
          <div class="vc-menu-sub" v-if="subMenus && subMenus.length > 0">
            <ul>
              <li class="title">{{ curMenuName }}</li>
              <template v-for="(subMenu, index) in subMenus">
                <li :key="index" v-if="subMenu.isShow == 'Y'" :class="{ active: subMenu.active }"
                  v-on:click="_gotoPage(subMenu.href, subMenu.name)">
                  {{ subMenu.name }}
                  <span class="menu-red-dot"
                    v-if="_todoSubMenuCount(subMenu) > 0">{{ _todoSubMenuCount(subMenu) > 99 ? '99+' :
                      _todoSubMenuCount(subMenu) }}</span>
                </li>
              </template>
              <li class="sub-footer" @click="_closeSubMenu()"><i class="fa fa-dedent"></i></li>
            </ul>
          </div>
        </div>
      </el-aside>

      <!-- 主要内容区 -->
      <el-main class="app-main">
        <router-view />
      </el-main>
    </el-container>
    <more-community ref="moreCommunity" />
    <view-menu-user-list ref="viewMenuUserModel" />
    <search-community-data-list ref="searchCommunityDataModel" />
  </el-container>
</template>

<script>
import { _getMenuCatalog, getMenuTree, jumpToMall, jumpToIot } from '@/api/user/menuApi'
import { getStoreInfo } from "@/api/user/indexApi"
import { listSystemInfo } from '@/api/system/systemInfoManageApi'
import { deepCopy, setCurrentCommunity, getCommunityId } from "@/utils/vc"
import { getCommunityName, _loadCommunityInfo } from '@/api/community/communityApi'
import moreCommunity from '@/components/community/moreCommunity.vue'
import viewMenuUserList from '@/components/system/viewMenuUserList.vue'
import searchCommunityDataList from '@/components/system/searchCommunityDataList.vue'
import { initSystem } from '@/api/util/vcApi'
import request from '@/utils/request'
import config from '@/conf/config'
import TODO_ITEMS from './todoItems'


export default {
  name: 'Layout',
  data() {
    return {
      catalogs: [],
      menuTree: [],
      subMenus: [],
      menuWidth: 80,
      menuId: '',
      curMenuName: '',
      activeMenu: '',
      activeSubMenu: 'communityList',
      searchText: '',
      username: '',
      curCommunityName: '',
      communitys: [],
      storeInfo: {
        storeTypeCd: '',
        storeId: ''
      },
      systemInfo: {
        systemSimpleTitle: '',
        companyName: '',
        logoUrl: '',
        version: ''
      },
      todoCounts: {},
      todoTotalCount: 0
    }
  },
  created() {
    let _user = JSON.parse(localStorage.getItem('user'));
    this.username = _user.name
    this.systemInfo.version = config.version
    this.getSystemInfo()
    this._loadStoreInfo()
    this.loadCatalogs()
    this.curCommunityName = getCommunityName()
    this.loadCommunity()
    initSystem()
    this._initTodoReminder()
  },
  beforeDestroy() {
    this._destroyTodoReminder()
  },
  components: {
    moreCommunity,
    viewMenuUserList,
    searchCommunityDataList
  },
  methods: {
    async getSystemInfo() {
      const { data } = await listSystemInfo({ page: 1, row: 1 });
      this.systemInfo.systemSimpleTitle = data[0].systemSimpleTitle
      this.systemInfo.companyName = data[0].companyName
      this.systemInfo.logoUrl = data[0].logoUrl
    },
    async loadCommunity() {
      const { communitys } = await _loadCommunityInfo()
      this.communitys = communitys
      this.curCommunityName = getCommunityName()

    },
    async _loadStoreInfo() {
      this.loading = true
      try {
        const res = await getStoreInfo()
        deepCopy(res, this.storeInfo);
      } catch (error) {
        console.error('登录失败：', error)
      } finally {
        this.loading = false
      }

    },
    async loadCatalogs() {
      this.loading = true
      try {
        const res = await _getMenuCatalog()
        if (res.code != 0) {
          return;
        }
        this.catalogs = res.data;
        if (this.catalogs && this.catalogs.length > 0) {
          this._changeMenuCatalog(this.catalogs[0])
        }
      } catch (error) {
        console.error('登录失败：', error)

      } finally {
        this.loading = false
      }
    },
    _changeMenuCatalog(_catalog, _isJump) {
      this.activeMenu = _catalog.caId;
      if (this._showModelDiv(_catalog)) {
        return;
      }
      if (_catalog.caId === '1') {
        this.$router.push('/#/pages/mall/product');
      }
      if (_catalog.url == 'IOT') {
        jumpToIot('/');
        return;
      }
      if (_catalog.url == 'MALL') {
        //获取用户名
        jumpToMall('/');
        return;
      }
      console.log(_catalog)
      if (_catalog.url != '#' && _isJump) {
        this._gotoPage(_catalog.url, _catalog.name)
        //return;
      }
      this.loadMenuTree(_catalog)
    },

    handleCommand(command) {
      if (command === 'logout') {
        // 处理退出登录

        localStorage.removeItem('token')
        localStorage.clear();
        this.$router.push('/login')
      } else if (command === 'zh' || command === 'en') {
        // 切换语言
        this.$i18n.locale = command
        localStorage.setItem('language', command)
      }
    },
    changeCommunity(community) {
      if (community == 'moreCommunity') {
        this.$refs.moreCommunity.open()
        return
      }
      setCurrentCommunity(community);
      this.curCommunityName = getCommunityName()
      window.location.href = "/"
    },
    handleMenuSelect(index) {
      // 处理菜单选择
      this.$router.push({ name: index })
    },
    loadMenuTree(_catalog) {
      getMenuTree(_catalog).then(res => {
        let _menus = res.data;
        _menus.sort(function (a, b) {
          return a.seq - b.seq
        });
        this.menuTree = _menus;
      })
    },
    switchMenu(_menu) {
      //设置菜单ID
      this.menuId = _menu.id;
      this.menuTree = this.refreshMenuActive(this.menuTree, _menu.id);
      this.subMenus = _menu.childs;
      console.log(this.subMenus)
      this.curMenuName = _menu.name;

      // 点击包含待办提醒项的一级菜单组即视为已查看该项提醒，消除对应闪烁因子
      TODO_ITEMS.forEach((item) => {
        if (_menu.childs && _menu.childs.some(function (_child) {
          return _child.href && this._hrefMatches(_child.href, item.matchHref)
        }, this)) {
          this._clearTodoBlinkForItem(item)
        }
      })

      if (!_menu.childs || _menu.childs.length < 1) {
        return;
      }
      //选中第一个
      this._gotoPage(_menu.childs[0].href, _menu.childs[0].name);
      //vc._fix_height()
    },
    refreshMenuActive(jsonArray, _id) {
      for (let menuIndex = 0; menuIndex < jsonArray.length; menuIndex++) {
        if (jsonArray[menuIndex].childs) {
          let _childs = jsonArray[menuIndex].childs;
          _childs.sort(function (_child, _newChild) {
            return _child.seq - _newChild.seq
          });
          jsonArray[menuIndex].childs = _childs;
        }

        if (_id === jsonArray[menuIndex].id) {
          //如果当前本身是打开状态，说明 需要关闭
          jsonArray[menuIndex].active = true;
          continue;
        }
        jsonArray[menuIndex].active = false;
      }
      return jsonArray;
    },
    _setSelectedMenusChild(_href) {
      for (var menuIndex = 0; menuIndex < this.menuTree.length; menuIndex++) {
        if (this.menuTree[menuIndex].childs) {
          var _childs = this.menuTree[menuIndex].childs;
          for (var childIndex = 0; childIndex < _childs.length; childIndex++) {
            if (_href == _childs[childIndex].href) {
              this.menuTree[menuIndex].childs[childIndex].active = true;
            } else {
              this.menuTree[menuIndex].childs[childIndex].active = false;
            }
          }
        }
      }
      this.$forceUpdate();
    },
    _gotoPage(_href, _tabName) {
      console.log(_href, _tabName)
      // 子菜单默认选中
      this._setSelectedMenusChild(_href)
      // 进入待办提醒项对应页面即视为已查看，消除该项闪烁因子
      TODO_ITEMS.forEach((item) => {
        if (_href && this._hrefMatches(_href, item.matchHref)) {
          this._clearTodoBlinkForItem(item)
        }
      })
      if (_href.indexOf('.html') > -1) {
        window.open(_href, '_blank')
        return
      }
      if (_href.indexOf('/#/') > -1) {
        _href = _href.replace('/#/', '/')
      }

      this.$router.push(_href).catch(err => {
        // 忽略重复导航错误
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
    },
    _showModelDiv: function (_catalog) {
      console.log(_catalog)
      if (_catalog.url.startsWith('?')) {
        let _modelName = _catalog.url.substring(1, _catalog.url.length);
        this.$refs[_modelName].open()
        return true;
      }
      return false;
    },
    _toIndex() {
      location.href = '/'
    },
    _closeSubMenu() {
      this.subMenus = []
      this.curMenuName = ''
    },

    // ========== 待办提醒（轮询 undo/list，60 秒；配置驱动见 todoItems.js） ==========
    _initTodoReminder() {
      this._todoPrevCounts = {}
      this._blinkItems = []
      this._todoTimer = null
      this._titleBlinkTimer = null
      this._originalTitle = document.title
      this._visibilityHandler = () => {
        if (!document.hidden) {
          this._pollTodos()
        }
      }
      document.addEventListener('visibilitychange', this._visibilityHandler)
      // 业务列表页查询/操作完成后派发对应事件，收到立即刷新角标，不等 60 秒轮询
      this._todoChangedHandler = () => {
        this._pollTodos()
      }
      TODO_ITEMS.forEach((item) => {
        if (item.refreshEvent) {
          window.addEventListener(item.refreshEvent, this._todoChangedHandler)
        }
      })
      this._pollTodos()
      this._todoTimer = setInterval(this._pollTodos, 60000)
    },
    _destroyTodoReminder() {
      if (this._todoTimer) {
        clearInterval(this._todoTimer)
        this._todoTimer = null
      }
      if (this._visibilityHandler) {
        document.removeEventListener('visibilitychange', this._visibilityHandler)
      }
      if (this._todoChangedHandler) {
        TODO_ITEMS.forEach((item) => {
          if (item.refreshEvent) {
            window.removeEventListener(item.refreshEvent, this._todoChangedHandler)
          }
        })
      }
      this._stopTitleBlink()
    },
    _pollTodos: function () {
      let _that = this
      if (document.hidden) {
        return
      }
      request({
        url: '/callComponent/undo/list',
        method: 'get',
        params: {
          communityId: getCommunityId(),
          page: 1,
          row: 10
        }
      }).then(response => {
        let _body = response.data || {}
        let _doing = _body.data ? _body.data : _body
        let _counts = {}
        TODO_ITEMS.forEach(function (item) {
          let _count = parseInt(_doing[item.key] || '0')
          if (isNaN(_count)) {
            _count = 0
          }
          _counts[item.key] = _count
        })
        _that._updateTodoCounts(_counts)
      }).catch(() => {
        // 轮询失败静默处理，不打断用户操作
      })
    },
    _updateTodoCounts(_counts) {
      let _total = 0
      let _increased = []
      TODO_ITEMS.forEach((item) => {
        let _prev = this._todoPrevCounts[item.key]
        let _count = _counts[item.key]
        // 闪烁触发：较上轮增加（首轮 prev 为空不闪，与改造前一致）
        if (_prev !== undefined && _count > _prev) {
          _increased.push(item)
        }
        this._todoPrevCounts[item.key] = _count
        this.$set(this.todoCounts, item.key, _count)
        _total += _count
      })
      this.todoTotalCount = _total
      if (_increased.length > 0) {
        this._startTitleBlink(_increased)
      }
    },
    _todoCountOf(key) {
      let _count = parseInt(this.todoCounts[key] || '0')
      return isNaN(_count) ? 0 : _count
    },
    // 菜单 href 匹配：包含匹配 + 边界校验（匹配串后不得紧跟路径字符，防止 complaint 误匹配 complaintType）
    _hrefMatches(href, matchHref) {
      if (!href || !matchHref) {
        return false
      }
      let _idx = href.indexOf(matchHref)
      if (_idx === -1) {
        return false
      }
      let _nextChar = href.charAt(_idx + matchHref.length)
      return _nextChar === '' || !/[A-Za-z0-9\-._~]/.test(_nextChar)
    },
    // 一级菜单组角标：组内任一 child 的 href 匹配提醒项，返回匹配项计数合计
    _todoMenuGroupCount(menu) {
      if (!menu.childs) {
        return 0
      }
      let _total = 0
      menu.childs.forEach((_child) => {
        if (!_child.href) {
          return
        }
        TODO_ITEMS.forEach((item) => {
          if (this._hrefMatches(_child.href, item.matchHref)) {
            _total += this._todoCountOf(item.key)
          }
        })
      })
      return _total
    },
    // 二级菜单项角标
    _todoSubMenuCount(subMenu) {
      if (!subMenu.href) {
        return 0
      }
      let _total = 0
      TODO_ITEMS.forEach((item) => {
        if (this._hrefMatches(subMenu.href, item.matchHref)) {
          _total += this._todoCountOf(item.key)
        }
      })
      return _total
    },
    // 铃铛面板条目：仅列计数>0的提醒项
    _todoBellEntries() {
      let _entries = []
      TODO_ITEMS.forEach((item) => {
        let _count = this._todoCountOf(item.key)
        if (_count > 0) {
          _entries.push({ item: item, count: _count })
        }
      })
      return _entries
    },
    _gotoTodoItem(item) {
      if (item) {
        this._clearTodoBlinkForItem(item)
        // 点进去即同步一次角标，避免列表已处理而角标仍显示旧数字
        this._pollTodos()
        this.$router.push(item.jumpTo).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err
          }
        })
      }
    },
    // 铃铛面板行点击：收起面板后跳转对应业务页
    _gotoTodoItemFromPanel(entry) {
      if (this.$refs.todoBellPopover) {
        this.$refs.todoBellPopover.doClose()
      }
      this._gotoTodoItem(entry.item)
    },
    // 某项待办视为已查看：prev 置当前计数（此后新增仍会再闪），并从闪烁文案中移除该项
    _clearTodoBlinkForItem(item) {
      if (!item) {
        return
      }
      this._todoPrevCounts[item.key] = this._todoCountOf(item.key)
      if (this._blinkItems && this._blinkItems.length > 0) {
        this._blinkItems = this._blinkItems.filter((_it) => _it.key !== item.key)
        if (this._blinkItems.length === 0) {
          this._stopTitleBlink()
        }
      }
    },
    _startTitleBlink(increasedItems) {
      if (!this._blinkItems) {
        this._blinkItems = []
      }
      increasedItems.forEach((item) => {
        if (!this._blinkItems.some((_it) => _it.key === item.key)) {
          this._blinkItems.push(item)
        }
      })
      if (this._titleBlinkTimer) {
        return
      }
      let _showTip = true
      let _that = this
      this._titleBlinkTimer = setInterval(function () {
        let _blinkText = ''
        if (_that._blinkItems && _that._blinkItems.length > 0) {
          let _labels = _that._blinkItems.map(function (item) { return _that.$t(item.blinkLabelKey) })
          _blinkText = '【' + _labels.join('】【') + '】' + _that.$t('layout.todoBlinkSuffix', { count: _that.todoTotalCount }) + ' - '
        }
        document.title = _showTip ? (_blinkText + _that._originalTitle) : _that._originalTitle
        _showTip = !_showTip
      }, 1000)
    },
    _stopTitleBlink() {
      this._blinkItems = []
      if (this._titleBlinkTimer) {
        clearInterval(this._titleBlinkTimer)
        this._titleBlinkTimer = null
      }
      if (this._originalTitle) {
        document.title = this._originalTitle
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 100vh;
}

.app-header {
  background-color: #1e2132;
  color: #fff;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
}

.logo {
  width: 100px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #409EFF;
  cursor: pointer;
}

.header-menu {
  border: none;
}

.header-right {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.margin-left {
  margin-left: 15px;
  color: #fff;
}

.user-info {
  color: #fff;
  cursor: pointer;
}

.app-aside {
  width: auto;
}

.menu-wrapper {
  height: 100%;
}

.el-menu-vertical {
  border: none;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 200px;
}

.app-main {
  background-color: #f5f7fa;
  height: calc(100vh - 60px);
  padding: 0px;
}

:deep(.el-menu--horizontal) {
  border-bottom: none;
}

:deep(.el-menu-item) {
  height: 50px;
  line-height: 50px;
}

:deep(.el-submenu__title) {
  height: 50px;
  line-height: 50px;
  padding: 0 20px !important;
}

:deep(.el-menu--collapse) {
  width: 64px;
}

:deep(.el-menu--collapse .el-submenu__title) {
  padding: 0 !important;
  text-align: center;
}

:deep(.el-menu--collapse .el-submenu__title i) {
  margin: 0;
  font-size: 20px;
}

:deep(.el-menu--popup) {
  min-width: 200px;
  background-color: #1e2132 !important;
}

:deep(.el-menu--popup .el-menu-item) {
  background-color: #1e2132;
  color: #fff;
}

:deep(.el-menu--popup .el-menu-item:hover) {
  background-color: #2a2f45;
}

:deep(.el-menu--popup .el-menu-item.is-active) {
  color: #409EFF;
}

.vc-menu {
  border-right: 1px solid #EFEFF0;

  .vc-menu-main {
    background-color: #1F2339;
    color: #838A9B;
    text-align: center;
    width: 80px;
    font-size: 14px;
    height: calc(100vh - 60px);
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: none;

    .active {
      background-color: #3E77FC;
      color: #FFFFFF;
    }
  }

  .vc-menu-main::-webkit-scrollbar {
    display: none;
  }

  ul {
    padding-inline-start: 0px;
    margin: 0;
    padding: 0;
  }

  li {
    margin: 0;
    padding: 0;
  }
}

.moreCommunity {
  font-weight: 600;
  color: #212529;
  font-size: 12px;
}

.vc-menu-main ul li {
  height: 45px;
  line-height: 45px;
  cursor: pointer;
  list-style-type: none;
  position: relative;
}

.vc-menu-main ul li:hover {
  background-color: #3E77FC;
  color: #FFFFFF;
}

.vc-menu-main ul li.title {
  color: #FFFFFF;
  height: 60px;
  font-size: 24px;
  line-height: 60px;
}

.vc-menu-main ul li.title a {
  text-decoration: none;
  cursor: pointer;
  color: #FFFFFF;
}

.vc-menu-sub {
  background-color: #FFFFFF;
  color: #545761;
  text-align: start;
  width: 110px;
  font-size: 14px;
  height: calc(100vh - 60px);
  overflow-x: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
}

.vc-menu-sub::-webkit-scrollbar {
  display: none;
}

.vc-menu-sub .active {
  background-color: #EAF0FE;
  color: #3E77FC;
}



.vc-menu-sub ul li {
  height: 40px;
  line-height: 40px;
  padding-left: 15px;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
}

.vc-menu-sub ul li.title {
  color: #4F525C;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  padding-left: 0px;
  border-bottom: 1px solid #F2F2F3;
  margin-bottom: 10px;
}

.vc-menu-sub ul li:hover {
  background-color: #EAF0FE;
  color: #3E77FC;
}

.vc-menu-sub ul li.sub-footer {
  background-color: #F6F6F7;
  text-align: center;
  position: fixed;
  bottom: 0;
  width: 100px;
}

/* ===== 报修待办提醒 ===== */
.todo-bell {
  position: relative;
  color: #fff;
  cursor: pointer;
  font-size: 18px;
  margin-right: 20px;
  line-height: 60px;
}

.todo-bell:hover {
  color: #409EFF;
}

.todo-badge {
  position: absolute;
  top: 10px;
  right: -12px;
  background-color: #f56c6c;
  color: #fff;
  border-radius: 8px;
  font-size: 10px;
  line-height: 14px;
  min-width: 14px;
  padding: 0 4px;
  text-align: center;
}

.menu-red-dot {
  position: absolute;
  top: 5px;
  right: 3px;
  background-color: #f56c6c;
  color: #fff;
  border-radius: 8px;
  font-size: 10px;
  line-height: 14px;
  min-width: 14px;
  padding: 0 4px;
  text-align: center;
  z-index: 1;
}

.todo-panel-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  cursor: pointer;
  font-size: 13px;
}

.todo-panel-row:hover {
  background-color: #f5f7fa;
  color: #409EFF;
}

.todo-panel-name {
  flex: 1;
}

.todo-panel-count {
  color: #f56c6c;
  font-weight: bold;
  font-size: 14px;
  margin-right: 8px;
}
</style>